import { render } from "./ContactSection.vue?vue&type=template&id=2d2e30eb"
import script from "./ContactSection.vue?vue&type=script&lang=js"
export * from "./ContactSection.vue?vue&type=script&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=2d2e30eb&lang=css"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__